import React from 'react';
import useTheme from 'branding/theme';
import getIconColor from '../../getIconColor';
const CalendarIcon = ({ type = 'brand', size = 'regular', styles, ...rest }) => {
    const { colors, sizing } = useTheme();
    const color = getIconColor(colors, type);
    const sizePx = sizing.widths.icon[size];
    return (React.createElement("svg", { width: sizePx, height: sizePx, viewBox: "0 0 43 39", style: styles, ...rest },
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "M-177-1651h1440V510H-177z" }),
            React.createElement("g", { strokeWidth: "2", stroke: color, strokeLinecap: "round" },
                React.createElement("path", { d: "M41.543 22.206v15.33H6.493V5.073h35.05V15.42M13.237 5.073h17.286M17.63 1.857v5.966M31.368 1.857v5.966M41.543 15.42H1.953" })))));
};
export default CalendarIcon;
//# sourceMappingURL=index.js.map